module.exports = __webpack_public_path__ + "static/loopcreate1-516f16069408563a3f385602f4320f81.png";